<!-- Top Navigation Panel -->
<div class="container mx-auto">
  <div class="grid h-14 grid-cols-[1fr_2fr_1fr] items-center gap-2">
    <pax-top-navigation-panel
      [enableBackButton]="enableBackButton"
      (back)="back.emit()"
    ></pax-top-navigation-panel>

    <!-- Header -->
    @if (headerText) {
    <div class="flex justify-center">
      <span class="font-semibold text-primary-prune">{{ headerText }}</span>
    </div>
    }

    <!-- Progress Bar -->
    @if (allMilestones) {
    <pax-progress-bar [allMilestones]="allMilestones"></pax-progress-bar>
    }
  </div>
  <ng-content></ng-content>
</div>
